import { render, staticRenderFns } from "./VGMAdd.vue?vue&type=template&id=3216ac20&scoped=true&"
import script from "./VGMAdd.vue?vue&type=script&lang=js&"
export * from "./VGMAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3216ac20",
  null
  
)

export default component.exports